import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { WetlandType } from '../constants/enums';
import './SearchFilter.css';

const SearchFilter = ({ onSearch, onClose }) => {
  const { t } = useLanguage();
  
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    municipality: '',
    wetlandType: '',
  });

  const handleInputChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = () => {
    onSearch(filters);
    onClose();
  };

  const handleReset = () => {
    setFilters({
      dateFrom: '',
      dateTo: '',
      municipality: '',
      wetlandType: '',
    });
  };

  return (
    <div className="search-filter-overlay" onClick={onClose}>
      <div className="search-filter-container" onClick={(e) => e.stopPropagation()}>
        <div className="search-filter-header">
          <h2>{t('search')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="search-filter-body">
          <div className="filter-group">
            <label>{t('dateFrom')}</label>
            <input
              type="date"
              value={filters.dateFrom}
              onChange={(e) => handleInputChange('dateFrom', e.target.value)}
              placeholder="dd.mm.yyyy"
            />
          </div>

          <div className="filter-group">
            <label>{t('dateTo')}</label>
            <input
              type="date"
              value={filters.dateTo}
              onChange={(e) => handleInputChange('dateTo', e.target.value)}
              placeholder="dd.mm.yyyy"
            />
          </div>

          <div className="filter-group">
            <label>{t('Tip vlažnog staništa')}</label>
            <select
              value={filters.wetlandType}
              onChange={(e) => handleInputChange('wetlandType', e.target.value)}
            >
              <option value="">{t('Odaberite tip vlažnog staništa')}</option>
              {Object.values(WetlandType).map((type) => (
                <option key={type} value={type}>
                  {t(type)}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="search-filter-footer">
          <button className="reset-button" onClick={handleReset}>
            {t('reset')}
          </button>
          <button className="search-button" onClick={handleSearch}>
            🔍 {t('search')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;